export default __webpack_public_path__ + "static/media/i59.0a4dfd98.svg";